import HeadlineTitle from './HeadTitle';
import PostTitle from './PostTitle';

export { HeadlineTitle, PostTitle };
